module.exports = __webpack_public_path__ + "img/corner-down-right.299306a2.svg";